import { localisedValue } from "utils"
import { t } from "i18next"
import theme from "utils/themeVars"
const projectDevelopersTransformer = data => {
  const transformedData = data?.existingProjectDevelopers?.map(item => {
    return {
      ...item,
      key: item?.id,
      label: localisedValue({ object: item, key: "name" }),
      value: item?.id.toString(),
    }
  })

  return transformedData
}
export default projectDevelopersTransformer
